/**
 * messageDomain — interprets `io.doclm.message.*`, one step per LLM invocation.
 *
 * ## The important behaviour here: most message runs are NOT steps
 * Verified in the captures, and it is the difference between a clean trace and a
 * flickering one.
 */

import { contentText } from 'src/content/ChatV2/steps/model/contentText';
import type {
  DomainInterpreter,
  NormalizedEvent
} from 'src/content/ChatV2/steps/model/types';
import {
  EVENT_DOMAIN,
  STEP_PHASE
} from 'src/content/ChatV2/steps/wire/eventType';
import {
  type Step,
  STEP_KIND,
  STEP_STATUS
} from 'src/content/ChatV2/types/steps';

export const messageDomain: DomainInterpreter = {
  domain: EVENT_DOMAIN.MESSAGE,

  identify(event) {
    return event.runId;
  },

  shouldCreate(event) {
    if (event.phase !== STEP_PHASE.DELTA) {
      return false;
    }
    const content = event.data.content;
    return typeof content === 'string' && content !== '';
  },

  kind() {
    return STEP_KIND.DEEP_RESEARCH;
  },

  apply(step, event: NormalizedEvent) {
    const next: Step = { ...step };
    const content = event.data.content;
    if (typeof content === 'string' && content !== '') {
      next.outputText = (step.outputText ?? '') + content;
    }
    if (
      event.data.input_complete === true &&
      step.status === STEP_STATUS.ACTIVE
    ) {
      next.status = STEP_STATUS.DONE;
    }
    return next;
  },

  settle(entry) {
    if (entry.type !== 'ai') {
      return null;
    }
    const content = contentText(entry.content) ?? '';
    if (content.trim() === '') {
      return null;
    }
    return {
      status: STEP_STATUS.DONE,
      kind: STEP_KIND.DEEP_RESEARCH,
      outputText: content
    };
  }
};
